import urls from "../../constants/urls.js";
import axios from "axios";

/**
 * The organization's registration with the Charidy app, behind the Charidy App
 * page.
 *
 * The backend decides everything, so the page only renders the answer: a
 * registered org gets its campaign (asked for with extend=campaign), and an
 * unregistered one gets the currency it would register in — empty when it has
 * no gateway to be paid in yet.
 * Registering creates (or reuses) the org's direct donation campaign and marks
 * it as the campaign the app's donations flow through.
 */

const emptyStatus = () => ({
  enrolled: false,
  campaign_id: 0,
  terms_url: "",
  currency: "",
  campaign: null,
});

const state = {
  charidyAppStatus: emptyStatus(),
  loadingCharidyApp: false,
  loadCharidyAppFailed: false,
  submittingCharidyApp: false,
};

const getters = {
  getCharidyAppStatus: (state) => state.charidyAppStatus,
  getLoadingCharidyApp: (state) => state.loadingCharidyApp,
  getLoadCharidyAppFailed: (state) => state.loadCharidyAppFailed,
  getSubmittingCharidyApp: (state) => state.submittingCharidyApp,
};

const mutations = {
  setCharidyAppStatus(state, data) {
    state.charidyAppStatus = { ...emptyStatus(), ...(data || {}) };
  },

  setLoadingCharidyApp(state, value) {
    state.loadingCharidyApp = value;
  },

  setLoadCharidyAppFailed(state, value) {
    state.loadCharidyAppFailed = value;
  },

  setSubmittingCharidyApp(state, value) {
    state.submittingCharidyApp = value;
  },
};

const actions = {
  // A failed read is reported, not turned into "not registered": the page is
  // where the org acts on the answer, so it must not offer to register an org
  // that may already be registered.
  fetchCharidyAppStatus({ commit }) {
    commit("setLoadingCharidyApp", true);
    commit("setLoadCharidyAppFailed", false);

    const orgId = localStorage.getItem("orgId");
    return axios
      .get(urls.charidyAppCampaign(orgId))
      .then((response) => {
        commit("setCharidyAppStatus", response.data);
        return response.data;
      })
      .catch(() => {
        commit("setLoadCharidyAppFailed", true);
        return null;
      })
      .finally(() => {
        commit("setLoadingCharidyApp", false);
      });
  },

  // Rejects on failure so the page can report it. On success it re-reads the
  // status, so the page shows the campaign the registration created.
  registerCharidyApp({ commit, dispatch }) {
    commit("setSubmittingCharidyApp", true);

    const orgId = localStorage.getItem("orgId");
    return axios
      .post(urls.charidyAppOptIn(orgId), { accepted: true })
      .then(() => dispatch("fetchCharidyAppStatus"))
      .finally(() => {
        commit("setSubmittingCharidyApp", false);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
